import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65a57447"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "websiteConfig",
  class: "mt-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-dark" }, "Change Detection Type", -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<option value=\"TEXT\" data-v-65a57447>Textual Changes</option><option value=\"IMAGE\" data-v-65a57447>Visual Changes</option><option value=\"DATA\" data-v-65a57447>Data Extraction</option><option value=\"SUBDOMAIN\" data-v-65a57447>Subdomain Changes</option><option value=\"SSL\" data-v-65a57447>SSL Cert. Alerts</option><option value=\"HEALTHCHECK\" data-v-65a57447>Healthcheck</option>", 6)
const _hoisted_9 = [
  _hoisted_3
]
const _hoisted_10 = { class: "mt-3 px-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "Textual Changes"),
  /*#__PURE__*/_createTextVNode(": We extract the text from the html of the submitted web pages and compare it on a daily basis. If we find a difference you will be notified and you can view the diff. ")
], -1))
const _hoisted_13 = { class: "mb-3 position-relative" }
const _hoisted_14 = {
  for: "name",
  class: "form-label"
}
const _hoisted_15 = { class: "dropup-center inline-block helper cursor-pointer" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 text-sm float-end",
  type: "button",
  id: `transformerHelper`,
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " ? ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-small p-2 ps-4 pe-4" }, [
  /*#__PURE__*/_createTextVNode(" A queryselector transforms the scraped HTML data and enables the precise extraction of certain elements such as headings or numbers. "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://cheerio.js.org/docs/basics/selecting"
  }, "Learn more"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Examples:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - \"h1, h2, h3, h4, h5, h5\""),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - \"a.my-link-class[@href]\""),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - \".col-xs-6:nth-child(2) .number\" "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("i", { class: "text-white" }, "Use [@href] to extract the href attribute")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "clearfix" }, null, -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "Visual Changes"),
  /*#__PURE__*/_createTextVNode(": We take a screenshot of the submitted websites and compare it on a daily basis. If we find a difference, you will be notified and can see the difference. We try to automatically remove cookie consent banners. If this does not work, you can set a custom cookie consent click selctor.")
], -1))
const _hoisted_22 = { class: "mb-3 position-relative" }
const _hoisted_23 = {
  for: "name",
  class: "form-label"
}
const _hoisted_24 = { class: "dropup-center inline-block helper cursor-pointer" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 text-sm float-end",
  type: "button",
  id: `transformerHelper`,
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " ? ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-small p-2 ps-4 pe-4" }, " If our automatic closing of cookie consent banners does not work, you can use a query selector to specify a button that must be clicked after loading before a screenshot is taken. ", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "clearfix" }, null, -1))
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "Data extraction"),
  /*#__PURE__*/_createTextVNode(": You can define a data model with multiple properties and their extractor queries. This will then be compared daily and if we find a difference, you will be notified and can see the difference. ")
], -1))
const _hoisted_31 = { class: "mb-4 position-relative" }
const _hoisted_32 = { class: "mb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label text-sm"
}, "From a list", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = {
  key: 0,
  for: "name",
  class: "form-label"
}
const _hoisted_36 = { class: "dropup-center inline-block helper cursor-pointer" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 text-sm float-end",
  type: "button",
  id: `transformerHelper`,
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " ? ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-small p-2 ps-4 pe-4" }, [
  /*#__PURE__*/_createTextVNode(" An extractorselector transforms the scraped HTML data and enables the precise extraction of certain elements such as headings or numbers. "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://cheerio.js.org/docs/basics/selecting"
  }, "Learn more"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Examples:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - \"h1, h2, h3, h4, h5, h5\""),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - \"a.my-link-class[@href]\""),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" - \".col-xs-6:nth-child(2) .number\""),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("i", { class: "text-white" }, "Use [@href] to extract the href attribute")
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Properties:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 3,
  class: "text-dark"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "Subdomain Changes"),
  /*#__PURE__*/_createTextVNode(": We will notify you of any new subdomains that are added to or removed from a domain. ")
], -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 4,
  class: "text-dark"
}
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"text-dark mb-3\" data-v-65a57447><b class=\"text-dark\" data-v-65a57447>SSL Changes</b>: We will inform you when your SSL certificate expires. We have defined the following thresholds and whenever a new one is reached you will be informed. </div><p class=\"text-dark inline ms-2\" data-v-65a57447><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>MORE THAN 30 DAYS - 2026-02-20T23:59:59.000Z</i><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>LESS THAN 30 DAYS - 2026-02-20T23:59:59.000Z</i><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>LESS THAN 7 DAYS - 2026-02-20T23:59:59.000Z</i><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>LESS THAN 6 DAYS - 2026-02-20T23:59:59.000Z</i><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>....</i><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>LESS THAN 1 DAYS - 2026-02-20T23:59:59.000Z</i><br data-v-65a57447><i class=\"text-dark ms-2\" data-v-65a57447>EXPIRED SINCE {N} DAYS - 2026-02-20T23:59:59.000Z</i><br data-v-65a57447></p>", 2)
const _hoisted_51 = [
  _hoisted_49
]
const _hoisted_52 = {
  key: 5,
  class: "text-dark"
}
const _hoisted_53 = {
  key: 0,
  class: "text-dark inline ms-2"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = {
  key: 0,
  class: "text-dark ms-2"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = {
  key: 1,
  class: "text-dark mb-3"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-dark" }, "HealthCheck", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedData.type) = $event)),
        class: "form-select mt-0 bg-primary"
      }, _hoisted_9, 512), [
        [_vModelSelect, _ctx.computedData.type]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.computedData.type === 'TEXT')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _createTextVNode("Queryselector (optional) "),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("ul", {
                    class: _normalizeClass(["dropdown-menu transformer-helper bg-dark", { show: _ctx.mouseOver }]),
                    "aria-labelledby": `transformerHelper`
                  }, _hoisted_18, 2)
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "name",
                placeholder: "Something like \".total-amount span\"",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedData.transformer) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedData.transformer]
              ]),
              _hoisted_19
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.computedData.type === 'IMAGE')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _createTextVNode("Cookie Consent Click Selector (optional) "),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("ul", {
                    class: _normalizeClass(["dropdown-menu transformer-helper bg-dark", { show: _ctx.mouseOver }]),
                    "aria-labelledby": `transformerHelper`
                  }, _hoisted_27, 2)
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "name",
                placeholder: "Something like \".cmp-button-accept-all\"",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedData.screenshotClickSelector) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedData.screenshotClickSelector]
              ]),
              _hoisted_28
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.computedData.type === 'DATA')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "ms-2",
                  id: "name",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.useList) = $event)),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ( _ctx.computedData.listSelector = ''))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.useList]
                ]),
                _hoisted_34,
                (_ctx.useList)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_35, [
                      _createTextVNode("List extract-selector (optional) "),
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("ul", {
                          class: _normalizeClass(["dropdown-menu transformer-helper bg-dark", { show: _ctx.mouseOver }]),
                          "aria-labelledby": `transformerHelper`
                        }, _hoisted_39, 2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.useList)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      class: "form-control",
                      id: "name",
                      placeholder: "You can iterate over elements using selectors like \".feature\"",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedData.listSelector) = $event))
                    }, null, 512)), [
                      [_vModelText, _ctx.computedData.listSelector]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _hoisted_40,
              _hoisted_41,
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedData.dataType, (value, name) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: name,
                    class: "data-type-row"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.computedData.dataType[name].key) = $event),
                      placeholder: "Property Name",
                      class: "form-control"
                    }, null, 8, _hoisted_42), [
                      [_vModelText, _ctx.computedData.dataType[name].key]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.computedData.dataType[name].value) = $event),
                      placeholder: "Something like \".total-amount span\"",
                      class: "form-control"
                    }, null, 8, _hoisted_43), [
                      [_vModelText, _ctx.computedData.dataType[name].value]
                    ]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.deleteDataType(name)),
                      class: "btn btn-outline-danger btn-small"
                    }, "-", 8, _hoisted_44)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addDataType && _ctx.addDataType(...args))),
                  class: "btn btn-outline-primary"
                }, "+")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.computedData.type === 'SUBDOMAIN')
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
        : _createCommentVNode("", true),
      (_ctx.computedData.type === 'SSL')
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_51))
        : _createCommentVNode("", true),
      (_ctx.computedData.type === 'HEALTHCHECK')
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            (_ctx.websiteId)
              ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                  _createTextVNode(" We will inform you immediately if this url has not been triggered at least once a day with a get/put/post request:"),
                  _hoisted_54,
                  _hoisted_55,
                  (_ctx.websiteId)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_56, _toDisplayString(_ctx.healthCheckUrl), 1))
                    : _createCommentVNode("", true),
                  _hoisted_57
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _hoisted_59,
                  _createTextVNode(": We will inform you if a Healtcheck Ping URL is not pinged at least once a day with a get/post or put request. You will see your ping url after creating it. ")
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}